class MultipleSizes extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleContact = this.handleContact.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(this.els.contact.element, 'click', this.handleContact)
    this.listeners.add(this.els.close.element, 'click', this.handleClose)
  }

  handleContact () {
    window.drawers.activeDrawerKey = ''

    window.zE('messenger', 'open')

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'client_service_chat_started',
    })
  }

  async handleClose () {
    window.drawers.activeDrawerKey = ''

    window.BAO.Cart.updateCartAttributes({
      multiple_sizes_prompt: true,
    })
  }
}

if (!customElements.get('multiple-sizes')) {
  customElements.define('multiple-sizes', MultipleSizes)
}
